var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-date"},[_c('img',{staticClass:"img",attrs:{"src":require("@design/center/assets/images/no-data.png"),"alt":""}}),_c('p',{staticClass:"txt tc"},[_vm._t("content")],2),_vm._t("operation")],2)}
var staticRenderFns = []

export { render, staticRenderFns }